#import "../../../../graphql-wrappers/graphql/fragments/edition-fragment.graphql"

mutation UnscheduleEdition($edition: EditionUnscheduleInput!) {
    editionUnschedule(input: $edition) {
        edition {
            ...EditionFragment
        }
    }
}
